export enum ROLES {
  FA = 'ROLE_FA',
  SUPER_ADMIN = 'ROLE_SUPER_ADMIN', // PRODUCT_PAGE_ADMIN || SUPER_ADMIN
  LOCAL_ADMIN = 'ROLE_ADMIN',
}
